import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 20px;
  height: 100vh;
  background: #1b68b3;
`;

export const MainDownContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 100vh;
  flex-direction: column;
  background: #1b68b3;
  // background: linear-gradient(0deg, rgba(27, 104, 179, 0.6) 0%, #1b68b3 99.97%);
  // background: 'linear-gradient(0deg, rgba(27, 104, 179, 0.6) 0%, #1b68b3 99.97%)';
  background-repeat: no-repeat;
  width: 100%;
  background-size: 255%;
  background-position: center top;
  @media screen and (max-width: 700px) {
    background: none;
    margin-top: -130px;
    width: 100%;
    height: 95vh;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
`;

export const OrText = styled.div`
  // width: 20%;
  margin-top: 20px;
  color: #fff;
  // @media screen and (max-width: 700px) {
  //   width: 90%;
  // }
`;

export const ContactText = styled.div`
  text-align: center;
  color: #ff9500;
  font-size: 12px;
  @media screen and (max-width: 700px) {
    width: 90%;
  }
`;

export const DirectlyReactText = styled.div`
  color: #cecece;
  text-align: center;

  width: 100%;
`;

export const ContentFooterAreaInsertDetails = styled.div`
  background: #fff;
  border-radius: 30px 30px;
  // margin-top: 50px;

  // min-height: 100vh;
  padding: 30px 30px;
  width: 30%;
  @media screen and (max-width: 880px) {
    width: 100%;
  }
`;

export const CancelButton = styled(Link)`
  // float: right;
  cursor: pointer;
  font-size: 17px;
  position: absolute;
  top: 31px;
  left: 25px;
  color: #2584e0;
}
`;

export const VehicleInspectionP = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #798696;
  margin: 20px auto;
  width: 50%;
`;

export const ContentVehicleInspectionH1Span = styled.span`
  color: #ff9900;
`;

export const VehicleInspectionArrowBack = styled.span`
  color: #2584e0;
  font-size: 14px;
`;

export const ContentVehicleInspectionH1 = styled.h1`
  margin: 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  text-align: center;
  color: #ffffff;
  align-self: center;
  margin: 0 auto;
`;

export const OpenNavSpan = styled.button`
  font-size: 30px;
  cursor: pointer;
  background: none;
  border: 0;
  color: #2584e0;
`;

export const InsertDetailsLabel = styled.label`
  color: #889bad;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
`;

export const VehicleDetailHeading = styled.h4`
  text-align: center;
  display: block;
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const ContactHeading = styled.h4`
  text-align: center;
  display: block;
  margin-top: 10px;
  margin-bottom: 30px;
  color: black;
`;

export const InsertDetailsMtB5 = styled.div`
  margin-top: 38px;
  text-align: center;
  margin-bottom: 0px;

  button {
    background: linear-gradient(90deg, #ff7a00 0%, #ff9900 94.74%);
    border-radius: 100px;
    border: 1px solid #ff7400;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #ffffff;
    padding: 14px 14px 15px;
    text-decoration: none;
    margin-bottom: 20px;
    width: 80%;
    :focus {
      outline: none;
      box-shadow: 0;
    }
  }
`;

export const InsertDetailsMtB6 = styled.div`
  margin-top: 0px;
  margin-bottom: 0px;
  width: 100%;
  background: #1b68b3;
  padding-left: 0px;
  padding-right: 0px;

  @media screen and (max-width: 700px) {
    width: 100%;

    padding-left: 20px;
    padding-right: 20px;
  }
  button {
    background: none;

    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;

    color: #ffffff;
    width: 100%;
    text-decoration: none;

    :focus {
      outline: none;
      box-shadow: 0;
    }
  }
`;
